import { Box } from '@mui/material';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Outlet } from 'react-router';

import { VersionChecker } from '@/components/versionChecker/VersionChecker.comp.tsx';
import DictionariesContextProvider from '@/context/dictionariesContext/DictionariesContext.provider.tsx';
import PageContextProvider from '@/context/pageContext/PageContext.provider.tsx';
import { UserContextProvider } from '@/context/userContext/UserContextProvider.util.tsx';
import Layout from '@/layouts/private/Layout.tsx';

export const RootLayout = () => {
  return (
    <>
      <VersionChecker />
      <ReactQueryDevtools initialIsOpen={false} />
      <PageContextProvider>
        <UserContextProvider>
          <DictionariesContextProvider>
            <Layout>
              <Box sx={{ width: '100%' }}>
                <Outlet />
              </Box>
            </Layout>
          </DictionariesContextProvider>
        </UserContextProvider>
      </PageContextProvider>
    </>
  );
};
